<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :destroy-on-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    fullscreen
    :custom-class="`${
      readonly ? 'custom-xxl custom-xxl-bottom0' : 'custom-xxl'
    }`"
  >
    <div class="map-choose-point">
      <el-row :gutter="10">
        <el-col :span="12">
          经度: {{ point[0] }},纬度:{{ point[1] }}
          <!--<el-input v-model="point.lng" placeholder="经度" />-->
        </el-col>
        <el-col :span="12">
          <!--<el-input v-model="point.lat" placeholder="纬度" />-->
        </el-col>
      </el-row>
      <div class="map-choose-view">
        <!-- <div class="map-cus-control">
          <map-control @change="openWTS" />
        </div> -->
        <open-map v-if="dialogVisible" ref="map1" @change="change" />
      </div>
    </div>
    <div v-if="!readonly" slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="ok()">确 定</el-button>
    </div>
  </el-dialog>
</template>
 
<script>
import OpenMap from "./GdMap.vue";
export default {
  name: "Choose",
  components: {
    OpenMap,
    // MapControl
  },
  props: {
    // 经纬度
    lnglat: {
      type: Array,
      default: function () {
        return [116.29920714, 39.681];
      },
    },
  },
  computed: {},
  data() {
    return {
      readonly: false,
      point: this.lnglat,
      dialogVisible: false,
      map: null,
      title: "选择坐标",
    };
  },
  watch: {
    lnglat(val) {
      this.point = val;
    },
  },
  mounted() {},
  methods: {
    open() {
      this.readonly = false;
      this.dialogVisible = true;
      this.title = "选择坐标";

      this.$nextTick(() => {
        if (this.lnglat[0] != 0) {
          this.$refs.map1.addPoint(this.lnglat, false);
        }
      });
    },
    detail() {
      this.readonly = true;
      this.dialogVisible = true;
      this.title = "查看位置";
      this.$nextTick(() => {
        if (this.lnglat[0] != 0) {
          this.$refs.map1.addPoint(this.lnglat, true);
        }
      });
    },
    change(lnglat) {
      if (!this.readonly) {
        this.point = lnglat;
      }
    },
    ok() {
      this.$emit("ok", this.point);
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss">
.map-choose-point {
  height: 100%;
  position: relative;
  overflow: hidden;

  .map-choose-view {
    position: absolute;
    top: 40px;
    left: 0;
    right: 0;
    bottom: 0px;
    overflow: hidden;
    height: auto;

    .map-cus-control {
      // background-color: rgb(12 24 48);
      position: absolute;
      bottom: 0;
      left: 0;
      width: 150px;
      height: 35px;
      line-height: 35px;
      //border: 2px solid red;
      z-index: 1000;
      padding: 0 10px;
    }
  }
}

.custom-xxl {
  position: relative;
  padding: 0;

  .el-dialog__body {
    //border: 2px solid red;
    position: absolute;
    top: 45px;
    bottom: 65px;
    width: 100%;
  }

  .el-dialog__footer {
    position: absolute;
    left: 0px;
    bottom: 0px;
    width: 100%;
  }

  &.custom-xxl-bottom0 {
    .el-dialog__body {
      bottom: 0;
    }
  }
}
</style>
